/* eslint-disable no-empty-pattern */
const api = require('../../firebaseConfig.js');

const state = {
  traits: []
};
const actions = {
  getTraits({ state }) {
    state.traits = [];
    api.ACTS_Traits.get().then(function(querySnapshot) {
      querySnapshot.forEach((doc) => {
        const newTrait = doc.data();
        newTrait.name = doc.id;
        state.traits.push(newTrait);
      });
    });
  },
  saveTrait({ dispatch }, payload) {
    dispatch('deleteTrait', payload.oldName)
      .then(() => {
        dispatch('createTrait', payload.newTrait);
      })
      .then(() => {
        dispatch('getTraits');
      });
  },
  addTrait({ dispatch }, newTrait) {
    dispatch('createTrait', newTrait).then(() => {
      dispatch('getTraits');
    });
  },
  removeTrait({ dispatch }, oldName) {
    dispatch('deleteTrait', oldName).then(() => {
      dispatch('getTraits');
    });
  },
  deleteTrait({}, oldName) {
    api.ACTS_Traits.doc(oldName)
      .delete()
      .catch(function(error) {
        console.log('Error deleting trait ' + error);
      });
  },
  createTrait({}, newTrait) {
    api.ACTS_Traits.doc(newTrait.name)
      .set({
        description: newTrait.description,
        type: newTrait.type ? newTrait.type : 'general',
        requirements: newTrait.requirements ? newTrait.requirements : []
      })
      .catch(function(error) {
        console.log('Error creating trait ' + error);
      });
  }
};

export default {
  namespaced: true,
  state,
  actions
};
